export default __webpack_public_path__ + "static/sunheroLogo-bf7b6a30e585199b1d2182f661d168c0.svg";